import { Input, Col, Row } from 'reactstrap';
import * as VscIcons from 'react-icons/vsc';
import Const from '../Const';
import Emoji from '../../images/emoji.png';
import EmojiPicker from 'emoji-picker-react';
import GetYourPostBase from './GetYourPostBase';
import { toolTippy, changeHandlerNoEvent, remainingChars } from '../Utils.js';
import Consierge from '../../images/consierge-greet-avatar.png';
import Send from '../../images/send-blue.png';
import { getAivideoInfoIcon, getRetryAivideoIcon, getUploadImageIckon, getToAIIckon } from '../../utils/PostButtonsAndIcons.js';

export default class GetYourPost extends GetYourPostBase {
	constructor(props) {
		super(props);
		this.state.aiInputClassName = "ai-input";
		this.state.isKeyboardUp = true; // this is a const value in this class
		this.state.layout = "Landscape";
		this.autoFocus = true;
	}

	getIckon() {
		return (
			<div className="nav-link nav-icon create-post" onClick={this.startPostProcess} >
				{ toolTippy(VscIcons.VscAdd, "Create Post", "bottom", [Const.DELAY, 0], "btn-desktop", null) }
			</div>
		)
	}

	getHeader() {
		return "Create Post";
	}

	getBottomBar(charCounter) {
		return ( 
			<Row className="media1 row-margin-01" > 			 
			  <Col className="p-0 m-0" lg={4} md={4}>
				<Row className="p-0">
				  <Col lg={2} md={2}>
					{
					  getUploadImageIckon(this)
					}
				  </Col>
				  <Col lg={2} md={2}>
					{
					  this.getEmoji()
					}
				  </Col>
				  <Col lg={2} md={2}>
					{
					  getToAIIckon(this)
					}
				  </Col>
				  <Col lg={2} md={2}>
					{
					  this.state.retryAIvideo &&
					  getAivideoInfoIcon(this)
					}
				  </Col>
				  <Col lg={2} md={2}>
					{
					  this.state.retryAIvideo &&
					  getRetryAivideoIcon(this)
					}
				  </Col>
				  <Col lg={2} md={2}></Col>
				</Row>
			  </Col>
			  <Col className="p-0" lg={8} md={8}>           
				{
				  remainingChars(charCounter)
				}
			  </Col>				
			</Row> 
		) 
	}

	getEmoji() {
		if (this.state.isModalWindowEnabled) {
			return(
				<div className="previewComponent pointer-view emojiImgDiv" onClick={this.toggleEmojiEmojiPicker}>
					 { toolTippy(Emoji, "Pick emoji", "bottom", [Const.DELAY, 0], "", null) }
				</div>
			)
		}
		else {
			return(
				<div className="previewComponent pointer-noview emojiImgDiv">
					 { toolTippy(Emoji, "Pick emoji", "bottom", [Const.DELAY, 0], "", null) }
				</div>
			)
		}
	}

	getToAIIckon() {
		if (this.state.isModalWindowEnabled) {
			return (
				<div className="previewComponent">
					<label id="labelAI" className="pointer-view">
						 <div className="avatar-ai-sm" onClick={ () => this.higlightSelectedElement('button1')} >
							  { toolTippy( Consierge, "Ask AI Concierge", "bottom", [Const.DELAY, 0], "", null) }
						  </div>
					</label>
				</div>
			)
		}
		else {
			return (
				<div className="previewComponent">
					<label id="labelAI" className="pointer-noview">
							<div className="avatar-ai-sm" >
							  { toolTippy( Consierge, "Ask AI Concierge", "bottom", [Const.DELAY, 0], "", null) }
						  </div>
					</label>
				</div>
			)
		}
    }
	  
	// Emoji

	toggleEmojiEmojiPicker = () => {
		let showEmojiEmojiPicker = !this.state.showEmojiEmojiPicker;
		let body = document.getElementById('main');
	
		this.setState({
		  showEmojiEmojiPicker: showEmojiEmojiPicker
		});
		if (showEmojiEmojiPicker) {
		  body.onclick = this.handleEmojiCloseClick;
		}
		else {
		  body.onclick = null;
		}
	};

	handleEmojiClick(emojiObject) {
		let textArea = document.getElementById('textArea');
		let startPos = textArea.selectionStart;
		let endPos = textArea.selectionEnd;
		let postText= this.state.value;
		let newPosition = startPos + emojiObject.emoji.length;
	
		textArea.value = postText.substring(0, startPos) + emojiObject.emoji + postText.substring(endPos);
		textArea.selectionStart = newPosition;
		textArea.selectionEnd = newPosition;
		textArea.focus();
		changeHandlerNoEvent(textArea.value, this);
	}

	handleEmojiCloseClick(e) {
		this.emojiCloseClickHandler(e);
	}

	getEmojiPicker() {
		return ( 
			<EmojiPicker onEmojiClick={this.handleEmojiClick} />
		);
	}
	  
	emojiCloseClickHandler(e) {
		let showEmojiEmojiPicker;
		let className;
		let cond1;
		let cond2;
	  
		showEmojiEmojiPicker = this.state.showEmojiEmojiPicker;
		className = e.target.className;
		cond1 = (typeof className === 'string') ? (className === '') : true;
		cond2 = (typeof className === 'string') ? !(className.indexOf('epr') > -1) : true;
		if (showEmojiEmojiPicker && (cond1 || cond2)) {
			this.toggleEmojiEmojiPicker();
		}
	}

	// AI concierge

	getNumberOfAIRequestsLeftDesktop(numberOfAIRequestsLeft, remainingRequestText) {
		let adjustedRemainingRequestText = this.adjustMarketPlaceCustomerText(numberOfAIRequestsLeft, remainingRequestText);
		
		return (
			 <Col lg={8} xs={10} className="center"> 
				<p id="remainingAIrequests" className="try">{ numberOfAIRequestsLeft + adjustedRemainingRequestText }</p> 	
			 </Col> 
		)
	}

	getProfileInfo(disabledAI) {
		return this.getProfileInfoDiv(disabledAI);
	}
	
	getRadioButtons(disabledAI) {
		return this.getRadioButtonsColumn(disabledAI);
	}

	getAIinput() {
		let loginUser = this.state.grandParent.state.loginUser;
		let aiLimitCond;

		if ((this.state.AIrequestOption === this.AI_IMAGE_CREATE) || (this.state.AIrequestOption === this.AI_POST_ILLUSTRATE) || (this.state.AIrequestOption === this.AI_POST_VIDEO_ILLUSTRATE)) {
			aiLimitCond = this.aiImageLimitCondition(loginUser);
		}
		else {
			aiLimitCond = this.aiPostLimitCondition(loginUser);
		}
		return (
				<Input id="aiInput" onChange={this.handleAIinputChange}
				    autoComplete="off"
					autoFocus = { this.autoFocus }
					name = "aiRequestTool" 
					maxLength = {this.AI_INPUT_MAX_LEN}
					placeholder = { this.state.AIrequestPlaceHolder }
					type = "text" required 
					value = { this.state.messageForAI }
					disabled = { 
								 !aiLimitCond ||
								 !this.state.submitToAINotSentYet 
							   }
					onFocus={ this.onFocusHandler }
					onBlur={ this.onBlurHandler} 
					className = "x-input ai-input-butmobile form-control">
			    </Input>
		)
	}

	getAIarrowButton(messageForAI, submitToAINotSentYet) {
		return (
				messageForAI && submitToAINotSentYet && this.state.isKeyboardUp 
				? <Col lg={1} md={1} xs={12} className="p-0 btn-look" onClick={ this.handleSubmitToAI }>
					<div className="send">
						<img src={ Send } className="pointer-view" alt="Avatar" />
					</div>
				  </Col>
				: <Col lg={1} md={1} xs={12} className="p-0 btn-look">
					<div className="send">
					  <img src={ Send } style = { this.LIGHT_FONT } alt="Avatar" />	
					</div>
				  </Col>
		)
	}

	getAIToggle() {
		let layout = this.state.layout;
		const styles = {
			container: {
			  textAlign: "center",
			  padding: "20px",
			},
			buttonContainer: {
			  margin: "20px",
			},
			button: {
			  padding: "10px 20px",
			  margin: "5px",
			  border: "1px solid #ccc",
			  backgroundColor: "#f0f0f0",
			  cursor: "pointer",
			},
			activeButton: {
			  padding: "10px 20px",
			  margin: "5px",
			  border: "1px solid #007bff",
			  backgroundColor: "#007bff",
			  color: "#fff",
			  cursor: "pointer",
			},
			landscape: {
			  margin: "20px auto",
			  width: "80%",
			  height: "200px",
			  backgroundColor: "#cce5ff",
			},
			portrait: {
			  margin: "20px auto",
			  width: "40%",
			  height: "400px",
			  backgroundColor: "#ffcce5",
			},
		  };
	
		return (
			<div style={styles.container}>
			  {/* <h1>Current Layout: {layout}</h1> */}
			  <div style={styles.buttonContainer}>
				<button
				  onClick={(event) => this.handleSwitch("Landscape", event)}
				  style={layout === "Landscape" ? styles.activeButton : styles.button}
				>
				  Landscape
				</button>
				<button
				   onClick={(event) => this.handleSwitch("Portrait", event)}
				  style={layout === "Portrait" ? styles.activeButton : styles.button}
				>
				  Portrait
				</button>
			  </div>
			 
			</div>
		  );
	}

	handleSwitch = (newLayout, event) => {
		event.preventDefault();
		event.stopPropagation();
		this.setState({layout: newLayout})
	};
}